/**
 * ロックゾーン内ターゲットの安定キー付け（量子化＋前フレーム中心との距離マッチ）。
 * TensorFlow に依存しないため単体テスト可能。
 */

/**
 * @param {{ p: { class: string }; x: number; y: number; w: number; h: number }} it
 * @param {number} [quantPx]
 */
export function itemKey(it, quantPx = 32) {
  const cx = it.x + it.w / 2;
  const cy = it.y + it.h / 2;
  const q = quantPx ?? 32;
  return `${it.p.class}_${Math.round(cx / q)}_${Math.round(cy / q)}`;
}

/**
 * @param {{ p: { class: string }; x: number; y: number; w: number; h: number }[]} inZoneTop
 * @param {Set<string>} prevKeys
 * @param {Map<string, { cx: number; cy: number }>} lastCenters
 * @param {{ lockMatchMaxDistPx?: number; lockTrackQuantPx?: number }} [opts]
 */
export function buildStableKeyedItems(inZoneTop, prevKeys, lastCenters, opts) {
  const quantPx = opts?.lockTrackQuantPx ?? 32;
  const raw = opts?.lockMatchMaxDistPx;
  const maxPx = raw === undefined ? 120 : raw;
  if (maxPx <= 0) {
    return inZoneTop.map((it) => ({ it, key: itemKey(it, quantPx) }));
  }

  const used = /** @type {Set<string>} */ (new Set());
  /** @type {{ it: (typeof inZoneTop)[0]; key: string }[]} */
  const out = [];

  for (const it of inZoneTop) {
    const mcx = it.x + it.w / 2;
    const mcy = it.y + it.h / 2;
    const classPrefix = `${it.p.class}_`;
    let bestK = null;
    let bestD = Infinity;
    for (const pk of prevKeys) {
      if (used.has(pk) || !pk.startsWith(classPrefix)) continue;
      const lc = lastCenters.get(pk);
      if (!lc) continue;
      const d = Math.hypot(mcx - lc.cx, mcy - lc.cy);
      if (d <= maxPx && d < bestD) {
        bestD = d;
        bestK = pk;
      }
    }
    if (bestK !== null) {
      used.add(bestK);
      out.push({ it, key: bestK });
    } else {
      out.push({ it, key: itemKey(it, quantPx) });
    }
  }
  return out;
}
